import {z} from 'zod';
import {UserLevel} from '@netx/core-user-next/constants';
import {
	makeOptionalPropsNullable,
	SchemaValidationErrorLabel,
} from '@netx/core-next/schema';

export const GroupUserSchema = z.object({
	firstName: z.string().nonempty(),
	lastName: z.string().nonempty(),
	email: z.string().email(),
	username: z.string().nonempty(),
	userType: z.nativeEnum(UserLevel),
	id: z.number(),
});
export default GroupUserSchema;

export const GroupUsersSchema = z.array(GroupUserSchema);

// **will come into play when adding a new groupUser
export const GroupUserSchemaNew = makeOptionalPropsNullable(
	GroupUserSchema.omit({
		email: true,
	}).partial({
		id: true,
	}),
);

/** all groupUser fields */
export const GroupUserField = GroupUserSchema.keyof().enum;

/** a true groupUser record */
export type IGroupUser = z.infer<typeof GroupUserSchema>;

/** a new groupUser record */
export type IGroupUserNew = z.infer<typeof GroupUserSchemaNew>;

/** groupUser form values schema */
export const GroupUserFormSchema = GroupUserSchema.pick({
	id: true,
	groupName: true,
});
export type IGroupUserFormValues = z.infer<typeof GroupUserFormSchema>;

export const SystemGroupUserAddFormSchema = z.object({
	ids: z
		.array(z.number().int().positive())
		.nonempty(SchemaValidationErrorLabel.REQUIRED),
});

export type ISystemGroupUserAddForm = z.infer<
	typeof SystemGroupUserAddFormSchema
>;
